import {useContext, useEffect, useRef, useState} from 'react';
import {ConfigContext} from '../../Providers/ConfigProvider';
import {EligibleChannelsEndpointResponseSuccess} from '../../../generated/types';
import {useApi} from '../../Providers/ApiProvider/ApiProvider';

export const useEligibleChannels = () => {
  const ref = useRef<boolean>(false);
  const [pending, setPending] = useState<boolean>(false);

  const [eligibleChannelsData, setEligibleChannelsData] =
    useState<EligibleChannelsEndpointResponseSuccess | null>(null);

  const {entrypoint, audience} = useContext(ConfigContext);

  const {fetchEligibleChannels} = useApi();

  useEffect(() => {
    if (!eligibleChannelsData && !ref.current) {
      ref.current = true;

      if (!entrypoint) {
        setEligibleChannelsData(null);
        return;
      }

      setPending(true);
      fetchEligibleChannels(entrypoint, audience)
        .then(setEligibleChannelsData)
        .finally(() => setPending(false));
    }
  }, [audience, fetchEligibleChannels, eligibleChannelsData, entrypoint]);

  return {
    eligibleChannels: eligibleChannelsData?.channels,
    noticeMessage: eligibleChannelsData?.notice_message,
    pending,
  };
};
